import { createTheme, type Theme } from '@mui/material/styles';
import './module-augmentation';
import { getPalette, type ThemeMode } from './palette';
import { typography } from './typography';
import { shape } from './shape';
import { components } from './components';

export const createAppTheme = (mode: ThemeMode = 'light'): Theme =>
  createTheme({
    palette: getPalette(mode),
    typography,
    shape,
    components,
  });

export const theme: Theme = createAppTheme('light');
